import { render, staticRenderFns } from "./rating-history.vue?vue&type=template&id=3e657899&scoped=true"
import script from "./rating-history.vue?vue&type=script&lang=js"
export * from "./rating-history.vue?vue&type=script&lang=js"
import style0 from "./rating-history.vue?vue&type=style&index=0&id=3e657899&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e657899",
  null
  
)

export default component.exports